/**
 * API Configuration
 *
 * Architecture:
 *   Browser → Express.js (Port 3000) → Flask Backend (Port 5001, internal)
 *
 * In ALL environments:
 *   - Browser ALWAYS calls same origin (window.location.origin)
 *   - Express.js proxies /api/* to Flask backend
 *   - Browser NEVER knows about Flask backend
 *
 * Development:
 *   - Browser: http://localhost:3000
 *   - Calls: http://localhost:3000/api/* → Express proxies to http://127.0.0.1:5001/api/*
 *
 * Production:
 *   - Browser: https://centextamilacademy.cloud
 *   - Calls: https://centextamilacademy.cloud/api/* → Express proxies to http://127.0.0.1:5001/api/*
 */

const getApiUrl = () => {
  // Always use same origin - Express handles all proxying
  return window.location.origin;
};

export const API_URL = getApiUrl();
export const SOCKET_URL = API_URL;

// Google Sign-In (OAuth Client ID). Not a secret -- Client IDs are meant to be embedded in
// frontend code; the backend independently re-verifies the token's audience against its own
// copy of this same value (GOOGLE_CLIENT_ID in backend/.env) before trusting it.
export const GOOGLE_CLIENT_ID = '95806710240-lsemoku5t608c6afe7t65n4df1pboi5f.apps.googleusercontent.com';
